module.exports = __webpack_public_path__ + "img/visual-dashboard2.002c668c.svg";